/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_SubtitleInputs */

const en_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your data processing preferences.`)
};

const de_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte deine Datenverarbeitungseinstellungen.`)
};

const fr_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerez vos preferences de traitement des donnees.`)
};

const es_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona tus preferencias de procesamiento de datos.`)
};

const it_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci le tue preferenze di trattamento dei dati.`)
};

const nl_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer je gegevensverwerkingsvoorkeuren.`)
};

const pl_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarzadzaj swoimi preferencjami przetwarzania danych.`)
};

const fi_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallinnoi tietojenkaesittelyasetuksiasi.`)
};

const da_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer dine databehandlingspraeferencer.`)
};

const sv_consent_settings_subtitle = /** @type {(inputs: Consent_Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera dina databehandlingsinstellningar.`)
};

/**
* | output |
* | --- |
* | "Manage your data processing preferences." |
*
* @param {Consent_Settings_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_subtitle = /** @type {((inputs?: Consent_Settings_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_subtitle(inputs)
	if (locale === "fr") return fr_consent_settings_subtitle(inputs)
	if (locale === "es") return es_consent_settings_subtitle(inputs)
	if (locale === "it") return it_consent_settings_subtitle(inputs)
	if (locale === "nl") return nl_consent_settings_subtitle(inputs)
	if (locale === "pl") return pl_consent_settings_subtitle(inputs)
	if (locale === "fi") return fi_consent_settings_subtitle(inputs)
	if (locale === "da") return da_consent_settings_subtitle(inputs)
	if (locale === "sv") return sv_consent_settings_subtitle(inputs)
	return en_consent_settings_subtitle(inputs)
});